export enum AvailabilityCode {
  NotInUse = -1,
  OutOfStock = 0,
  LowOnStock = 1,
  InStock = 2,
  SufficientlyInStock = 3
}
